import axios from '../utils/axios';


export default function fetchDailyCompanyDashboard(adminId,params) {
        return axios.get(`/admin/`+ adminId +`/dailyCompanyDashboard` , { params });
}
